/* Calls that cost money ask first.
   A call Sramika connects is free for the first few in a window; after that it costs a
   fee taken from the customer's wallet - only when the call connects. The server says
   so before placing the call:
     409 PAID_CALL_CONFIRM      - there is enough balance; the customer confirms the price
     402 INSUFFICIENT_BALANCE   - there is not; the customer adds money first
   callWithWalletGate shows the right pop-up (WalletGateHost, mounted once in App) and
   places the call again once the customer has agreed or added money. Direct calls are
   never charged, so for them the server never answers with either code. */

let host = null;

export function registerWalletGateHost(fn) {
  host = fn;
  return () => { if (host === fn) host = null; };
}

export const WALLET_GATE_CANCELLED = "WALLET_GATE_CANCELLED";

const GATE_CODES = new Set(["PAID_CALL_CONFIRM", "INSUFFICIENT_BALANCE", "INSUFFICIENT_FUNDS", "LAST_FREE_CALL"]);

/** Asks the host directly (app calls: the last free call, a driver's own car); "call" or "cancel". */
export const askGate = (detail) => (host ? host(detail) : Promise.resolve(detail.kind === "own" ? "cancel" : "call"));

/** placeCall({ confirmPaid }) must send confirmPaid with the request. */
export async function callWithWalletGate(placeCall) {
  let confirmPaid = false;
  for (let attempt = 0; attempt < 4; attempt++) {
    try {
      return await placeCall({ confirmPaid });
    } catch (err) {
      if (!GATE_CODES.has(err?.code) || !host) throw err;
      const answer = await host({
        kind: err.code === "PAID_CALL_CONFIRM" ? "paid" : err.code === "LAST_FREE_CALL" ? "last" : "low",
        fee: Number(err.fee ?? err.needed ?? 0),
        balance: Number(err.balance ?? 0),
        resetsAt: err.resetsAt || null,
        free: err.free || null,
        hours: err.hours || null,
      });
      if (answer !== "call") {
        const cancelled = new Error("The customer did not go ahead with the call");
        cancelled.code = WALLET_GATE_CANCELLED;
        throw cancelled;
      }
      confirmPaid = true; // they have seen the price
    }
  }
  throw new Error("Could not place the call");
}
